import { default as BaseIconButton } from '@mui/joy/IconButton';
import { forwardRef, type JSX, useMemo } from 'react';
import { SMALL_ICON_BUTTON_ID_CLASSNAME } from './consts';
import { smallIconButtonIconVariants, smallIconButtonVariants } from './styles';
import type { SmallIconButtonProps } from './types';

const SmallIconButton = forwardRef<HTMLButtonElement, SmallIconButtonProps>(
  (props, ref): JSX.Element => {
    const {
      size,
      Icon,
      IconNode,
      className,
      iconClassName: _iconClassName,
      variant = 'solid',
      stroke = 'currentColor',
      strokeWidth,
      ...rest
    } = props;

    const iconButtonClassName = smallIconButtonVariants({
      className: [SMALL_ICON_BUTTON_ID_CLASSNAME, className],
      size,
      variant,
    });

    const iconClassName = smallIconButtonIconVariants({
      className: _iconClassName,
      size,
    });

    const buildIconProps = useMemo(() => {
      const iconProps: React.SVGProps<SVGSVGElement> = {};
      if (iconClassName) {
        iconProps.className = iconClassName;
      }
      if (stroke) {
        iconProps.stroke = stroke;
      }
      if (strokeWidth) {
        iconProps.strokeWidth = strokeWidth;
      }

      return iconProps;
    }, [iconClassName, stroke, strokeWidth]);

    return (
      <BaseIconButton ref={ref} {...rest} className={iconButtonClassName}>
        {Icon ? <Icon {...buildIconProps} /> : IconNode}
      </BaseIconButton>
    );
  },
);

SmallIconButton.displayName = 'SmallIconButton';

export default SmallIconButton;
